import { sendApi } from "@/utils/api";
export const security = async (action) => {
    try{
        const res = await sendApi({ 
            action: action,
            control:'security'
        });
        return res.status === 'success'
    }catch(e){
        console.error(e)
        return false
    }
}
